import services from "@src/Services";

export const profileInitialState = {
  name: undefined,
  email: undefined,
  permissionLevel: undefined,
};

export const getMapprofileData = (response: ProfileResponseType) => {
  const profileData = [
    {
      title: "Name",
      content: response?.name,
    },
    {
      title: "Email",
      content: response?.email,
    },
    {
      title: "Permission Level",
      content: response?.permissionLevel,
    },
  ];
  return profileData;
};

export const getUserDetails = async () => {
  try {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const res: any = await services.get(`/user`);

    if (!res.error) {
      return { data: res?.data?.data };
    }
    return { data: null, error: "Something went wrong !" };
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
  } catch (err: any) {
    return {
      error: err?.error?.message || "Something went wrong!",
    };
  }
};
